import { connect } from 'react-redux';

export default function cannyConnect(mapStateToProps, mapDispatchToProps, options) {
  return connect(mapStateToProps, mapDispatchToProps, null, options);
}
